import { useQuery } from 'hooks/apollo';
import useDataSource from 'hooks/useDataSource';
import { useEffect, useRef, useState } from 'react';
import { useAccessibilityReview } from './context';
import { GET_ACCESSIBILITY_PAGE_INVENTORY, PAGE_INVENTORY_PAGE_SIZE } from './graphql';
import { mergeInventoryPages, PAGE_TYPE } from './viewModel';

export const usePageInventory = ({ pageType = PAGE_TYPE.ALL, enabled = true } = {}) => {
  const { dataSource } = useDataSource();
  const { scope } = useAccessibilityReview();
  const [pageSkip, setPageSkip] = useState(0);
  const [inventory, setInventory] = useState(null);
  const requestKey = `${scope?.id || ''}:${pageType}`;
  const requestKeyRef = useRef(requestKey);
  requestKeyRef.current = requestKey;

  useEffect(() => {
    setPageSkip(0);
    setInventory(null);
  }, [enabled, dataSource?.id, requestKey]);

  useQuery(GET_ACCESSIBILITY_PAGE_INVENTORY, {
    variables: {
      dataSourceId: dataSource?.id,
      pageType,
      first: PAGE_INVENTORY_PAGE_SIZE,
      skip: pageSkip,
    },
    skip: !enabled || !dataSource?.id || !scope?.id,
    fetchPolicy: 'network-only',
    onCompleted: ({ dataSource: inventoryDataSource }) => {
      if (requestKeyRef.current !== requestKey) return;
      const page = inventoryDataSource?.accessibilityReviewScopes?.find(({ id }) => id === scope.id)?.pageInventory;
      if (!page) return;
      setInventory(current => mergeInventoryPages(current, page, requestKey));
      if (page.hasMore && page.nextSkip != null) {
        setPageSkip(current => (current === pageSkip ? page.nextSkip : current));
      }
    },
  });

  return inventory;
};
